export function isNull(val: any): boolean {
  if (val === null || val === undefined || val === '' || JSON.stringify(val) === '{}' || JSON.stringify(val) === '[]') {
    return true;
  }
  return false;
}

export function isNotNull(val: any): boolean {
  return !isNull(val);
}
// 生成随机数
export function randomString(len: number = 32) {
  const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  const maxPos = $chars.length;
  let randomStr = '';
  for (let i = 0; i < len; i++) {
    randomStr += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return randomStr;
}